import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import moment from "moment-timezone";
import { useForm, Controller } from "react-hook-form";

import ModalIndex from "@Modals/layout/index";
import TextareaForm from "@components/textareaForm/TextareaSimple";

import { EvaluationObjective } from "@services/all.services";

import NotationPreview from "./NotationPreview";

export default function ModalUpsertObjective(props) {
  const { isOpen, onClickClose, selectedCriteria, assignedEmployee, readOnly } =
    props;
  const { t: translator } = useTranslation("assesment.frequency");
  const { handleSubmit, control, reset } = useForm();

  useEffect(() => {
    if (isOpen && selectedCriteria) {
      const objective = selectedCriteria.notation?.EvaluationObjective;

      reset({
        nextObjective: objective?.nextObjective || "",
        availableMeans: objective?.availableMeans || "",
        mainObjective: objective?.mainObjective || "",
      });
    }
  }, [selectedCriteria, isOpen]);

  const [isSaving, setSaving] = useState(false);
  async function onSuccess(formValue) {
    setSaving(true);
    const hasChanges = checkChanges(formValue);

    if (hasChanges) {
      await EvaluationObjective.insert({
        ...formValue,
        assignedEmployee,
        lastUpdate: moment().format("YYYY-MM-DD"),
        lastUpdateHour: moment().format("HH:mm:ss"),
        EvaluationCriteria: selectedCriteria._id,
        Enterprise: localStorage.getItem("enterpriseId"),
      });
    }

    setSaving(false);
    onClickClose();
  }

  function checkChanges(formValue) {
    const lastObjective = selectedCriteria.notation?.EvaluationObjective;

    if (!lastObjective) {
      return true;
    }

    return (
      lastObjective?.nextObjective !== formValue.nextObjective ||
      lastObjective?.availableMeans !== formValue.availableMeans ||
      lastObjective?.mainObjective !== formValue.mainObjective
    );
  }

  if (!selectedCriteria) {
    return null;
  }

  return (
    <ModalIndex
      isOpen={isOpen}
      onClickClose={onClickClose}
      buttonType={readOnly ? "none" : "double"}
      buttonOptions={{
        click: handleSubmit(onSuccess),
        color: "green",
        title: translator("Enregistrer"),
      }}
      buttonCancelOptions={{
        click: () => onClickClose(),
        color: "outlined",
        title: translator("Annuler"),
      }}
      isLoading={isSaving}
    >
      <div className="arh-w-full ">
        <div className="arh-w-full arh-flex-col arh-items-center ">
          <span className="arh-font-poppins arh-text-[13px] arh-font-normal arh-text-black ">
            {translator(selectedCriteria.evaluationType)}
          </span>
          <h3 className="arh-my-[1rem] arh-mb-0 arh-text-center arh-font-poppins arh-text-xl arh-font-semibold arh-text-black">
            {selectedCriteria.name}
          </h3>
          <NotationPreview
            note={selectedCriteria?.notation?.note}
            evaluationFormat={selectedCriteria.evaluationFormat}
          />
        </div>

        <div className="arh-mt-[3rem] arh-w-full ">
          <div className="arh-mb-[1rem] arh-w-full arh-rounded-[7px] arh-border arh-border-solid arh-border-[#F2F4F7] arh-px-[1.5rem] arh-py-[1rem] ">
            <Controller
              control={control}
              name="nextObjective"
              render={({ field: { onChange, value } }) => (
                <TextareaForm
                  classLabel="arh-text-left arh-mb-[1rem] "
                  label={translator("Objectifs pour la prochaine évaluation")}
                  classInput="!arh-border-0 !arh-p-0 arh-min-h-[5rem]  "
                  placeholder={translator("Texte ici")}
                  value={value}
                  onChange={onChange}
                  readOnly={readOnly}
                />
              )}
            />
          </div>

          <div className="arh-mb-[1rem] arh-w-full arh-rounded-[7px] arh-border arh-border-solid arh-border-[#F2F4F7] arh-px-[1.5rem] arh-py-[1rem]">
            <Controller
              control={control}
              name="availableMeans"
              render={({ field: { onChange, value } }) => (
                <TextareaForm
                  classLabel="arh-text-left arh-mb-[1rem] "
                  label={translator("Moyens disponibles")}
                  classInput="!arh-border-0 !arh-p-0 arh-min-h-[5rem]  "
                  placeholder={translator("Texte ici")}
                  value={value}
                  onChange={onChange}
                  readOnly={readOnly}
                />
              )}
            />
          </div>

          <div className="arh-mb-[1rem] arh-w-full arh-rounded-[7px] arh-border arh-border-solid arh-border-[#F2F4F7] arh-px-[1.5rem] arh-py-[1rem]">
            <Controller
              control={control}
              name="mainObjective"
              render={({ field: { onChange, value } }) => (
                <TextareaForm
                  classLabel="arh-text-left arh-mb-[1rem] "
                  label={translator("Objectif général")}
                  classInput="!arh-border-0 !arh-p-0 arh-min-h-[5rem]  "
                  placeholder={translator("Texte ici")}
                  value={value}
                  onChange={onChange}
                  readOnly={readOnly}
                />
              )}
            />
          </div>
        </div>
      </div>
    </ModalIndex>
  );
}
